import { Colors, Language, Lightning, Router, Storage } from "@lightningjs/sdk";
import { primaryColor } from "../Lib/Common";

export class OperatorItem extends Lightning.Component {
  static _template() {
    return {
      h: 100,
      w: 200,
      collision: true,
      Focus: {
        rect: true,
        w: (w) => w,
        h: (h) => h,
        mountY: 0,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: 0,
          stroke: 0,
          strokeColor: primaryColor,
          blend: 1,
          fillColor: Colors("#0A0A0A").alpha(0.8).get(),
        },
      },
      Content: {
        rect: true,
        w: (w) => w,
        h: (h) => h - 12,
        mountY: 0,
        color: Colors("#0A0A0A").alpha(0.8).get(),
        flex: { direction: "column" },
        Title: {
          y: 10,
          x: 10,
          text: {
            text: "Test",
            fontSize: 28,
            maxLines: 1,
            wordWrapWidth: 180,
            wordWrap: false,
            textOverflow: "ellipsis",
          },
        },
        Subtitle: {
          x: 10,
          alpha: 0,
          text: {
            text: Language.translate("current_operator_title"),
            fontSize: 20,
          },
        },
      },
    };
  }
  _init() {
    this._focusAnimation = this.animation({
      duration: 0.3,
      actions: [
        {
          t: "Focus",
          p: "shader.fillColor",
          v: {
            0: Colors("#0A0A0A").alpha(0.8).get(),
            1: primaryColor,
          },
        },
      ],
    });
  }
  async _handleEnter() {
    const currentOperator = Storage.get("current_operator");
    if (currentOperator.operador === this.operator.id) {
      return;
    }
    const operator = {
      operador: this.operator.id,
      nombre_operador: this.operator.name,
      max_devices: this.operator.max_devices,
    };

    this.fireAncestors('$canChangeDevice', operator, currentOperator);
  }
  _active() {
    this.tag("Title").text.text = this.operator.name;
    const currentOperator = Storage.get("current_operator");
    this.tag("Subtitle").alpha =
      this.operator.id === currentOperator.operador ? 1 : 0;
  }

  _focus() {
    if (this._focusAnimation) {
      this._focusAnimation.start();
    }
  }

  _unfocus() {
    this._focusAnimation.stop();
  }
  static get height() {
    return 100;
  }

  static get width() {
    return 200;
  }
}
